import React, { useState } from 'react'
import { SidebarProvider } from 'units/dashboard/context/SidebarProvider';
import PlanForm from './planForm/PlanForm'
import { ProgressBar } from 'react-loader-spinner'
import Header from 'units/dashboard/components/Header';
import Footer from 'units/dashboard/components/Footer';
import AdminSidebar from '../components/AdminSidebar';
export default function CreatePlan() {
    const [loading,setLoading]=useState(false)
  return (
    <>
          <SidebarProvider>
            <nav className="border-b border-slate-100 dark:bg-zinc-800 print:hidden flex items-center fixed top-0 right-0 left-0 bg-white z-10 dark:border-zinc-700">
              <Header/>
            </nav>
    
            <div className="vertical-menu rtl:right-0 fixed ltr:left-0 bottom-0 top-16 h-screen border-r bg-slate-50 border-gray-50 print:hidden dark:bg-zinc-800 dark:border-neutral-700 z-10">
              <AdminSidebar/>
            </div>
          </SidebarProvider>
    
          {loading ? (
            <div className="flex justify-center items-center h-screen">
              <ProgressBar
                visible={true}
                height="80"
                width="80"
                color="#4fa94d"
                ariaLabel="progress-bar-loading"
                wrapperStyle={{}}
                wrapperClass=""
              />
            </div>
          ) : (
            <div className="flex flex-col min-h-screen mt-4">
              <div className="main-content flex-grow pt-16 pb-12">
                <div className="container-fluid px-[0.625rem] mt-10">
                  <div className="grid grid-cols-1 mb-2">
                    <div className="flex items-center justify-between">
                      <h4 className="mb-sm-0 text-xl font-semibold grow text-gray-800 ">
                        ایجاد طرح
                      </h4>
                      <nav className="flex" aria-label="Breadcrumb"></nav>
                    </div>
                  </div>
                  <h1 className="text-md mr-2">
                   
        لطفا  مشخصات طرح خود را تعیین کنید.
                  </h1>
                </div>
                <div className="min-h-screen flex items-center justify-center p-2  my-2">
                  <div className="w-full max-w-2xl rtl ">
                    <PlanForm/>
    
                  </div>
                </div>
                <Footer />
              </div>
            </div>
          )}
        </>
  
  )
}
